import { Box, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
	readOnlyTarget: {
		borderRadius: theme.radius.sm,
		fontSize: theme.fontSizes.xs,
		color: theme.other.getColor('text/secondary/default'),
		backgroundColor: theme.other.getColor('fill/primary/default'),
		marginRight: theme.spacing.xs,
	},
}));

export interface OperatorMenuReadOnlyProps {
	label: string;
	className?: string;
}

export function OperatorMenuReadOnly({
	label,
	className,
}: OperatorMenuReadOnlyProps) {
	const { classes, cx } = useStyles();

	return (
		<Box
			data-testid="filter-operator-button-readonly"
			className={cx(classes.readOnlyTarget, className)}
		>
			{label}
		</Box>
	);
}
